"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFaqsPublicFaqNoValidation = exports.PostAccumulationsPaymentsRequestValidation = exports.getAccumulationsPaymentsValidation = exports.getAccumulationsSummaryValidation = exports.getAccumulationsDailyValidation = exports.getAccumulationsValidation = void 0;
var utils_1 = require("./utils");
// [Accumulation]
function getAccumulationsValidation(getAccumulationsRequest) {
    var errorList = [];
    var params = getAccumulationsRequest.params;
    if (!params.mallNo) {
        utils_1.addErrorList(errorList, 'mallNo', 'GET_ACCUMULATIONS_MALLNO_ERROR');
    }
    if (!params.memberNo) {
        utils_1.addErrorList(errorList, 'memberNo', 'GET_ACCUMULATIONS_MEMBERNO_ERROR');
    }
    if (!params.periodType) {
        utils_1.addErrorList(errorList, 'periodType', 'GET_ACCUMULATIONS_PERIODTYPE_ERROR');
    }
    if (!params.startDateTime) {
        utils_1.addErrorList(errorList, 'startDateTime', 'GET_ACCUMULATIONS_STARTDATETIME_ERROR');
    }
    if (!params.endDateTime) {
        utils_1.addErrorList(errorList, 'endDateTime', 'GET_ACCUMULATIONS_ENDDATETIME_ERROR');
    }
    return errorList;
}
exports.getAccumulationsValidation = getAccumulationsValidation;
function getAccumulationsDailyValidation(getAccumulationsDailyRequest) {
    var errorList = [];
    var params = getAccumulationsDailyRequest.params;
    if (!params.mallNo) {
        utils_1.addErrorList(errorList, 'mallNo', 'GET_ACCUMULATIONS_DAILY_MALLNO_ERROR');
    }
    return errorList;
}
exports.getAccumulationsDailyValidation = getAccumulationsDailyValidation;
function getAccumulationsSummaryValidation(getAccumulationsSummaryRequest) {
    var errorList = [];
    var params = getAccumulationsSummaryRequest.params;
    if (!params.mallNo) {
        utils_1.addErrorList(errorList, 'mallNo', 'GET_ACCUMULATIONS_SUMMARY_MALLNO_ERROR');
    }
    if (!params.startDateTime) {
        utils_1.addErrorList(errorList, 'startDateTime', 'GET_ACCUMULATIONS_SUMMARY_STARTDATETIME_ERROR');
    }
    if (!params.endDateTime) {
        utils_1.addErrorList(errorList, 'endDateTime', 'GET_ACCUMULATIONS_SUMMARY_ENDDATETIME_ERROR');
    }
    return errorList;
}
exports.getAccumulationsSummaryValidation = getAccumulationsSummaryValidation;
function getAccumulationsPaymentsValidation(getAccumulationsPaymentsRequest) {
    var errorList = [];
    var params = getAccumulationsPaymentsRequest.params;
    if (params.searchType !== 'ALL') {
        if (params.keyword === '') {
            utils_1.addErrorList(errorList, 'keyword_empty', 'ACCUMULATION_PAYMENT_KEYWORD_IS_EMPTY');
        }
    }
    if (params.searchType === 'PAYMENT_NO' && isNaN(params.keyword)) {
        utils_1.addErrorList(errorList, 'keyword_empty', 'ACCUMULATION_PAYMENT_PAYMENT_NO_MUST_NUMBER');
    }
    if (params.immediately !== false) {
        if (params.statuses === '') {
            utils_1.addErrorList(errorList, 'statuses', 'ACCUMULATION_PAYMENT_CHECKBOX_MUST_SELECT');
        }
    }
    return errorList;
}
exports.getAccumulationsPaymentsValidation = getAccumulationsPaymentsValidation;
function PostAccumulationsPaymentsRequestValidation(postAccumulationsPaymentsRequest, setNotification) {
    var errorList = [];
    var data = postAccumulationsPaymentsRequest.data;
    var temp = 1000 * 60 * 60;
    var paymentYmdt = Date.parse(data.paymentRequestDate) + data.paymentRequestHour * temp;
    var notificationYmdt = Date.parse(data.notificationRequestDate) + data.notificationRequestHour * temp;
    if (data.mallNo === 0) {
        utils_1.addErrorList(errorList, 'mallNo', 'ACCUMULATION_PAYMENT_REQUEST_ADD_MALL_NO');
    }
    if (data.amount === null) {
        utils_1.addErrorList(errorList, 'amount', 'ACCUMULATION_PAYMENT_REQUEST_PAYMENT_AMOUNT_ALERT_EMPTY');
    }
    if (!data.immediately && Date.parse(data.paymentRequestDate) + data.paymentRequestHour * temp < new Date().getTime()) {
        utils_1.addErrorList(errorList, 'paymentRequestDate', 'ACCUMULATION_PAYMENT_REQUEST_PAYMENT_TIME_SET_OLD_TIME_ALERT');
    }
    if (data.reason === '') {
        utils_1.addErrorList(errorList, 'reason', 'ACCUMULATION_PAYMENT_REQUEST_ADD_REASON_ALERT_EMPTY');
    }
    if (setNotification && new Date().getTime() > notificationYmdt) {
        utils_1.addErrorList(errorList, 'notificationRequestDate', 'ACCUMULATION_PAYMENT_REQUEST_ADD_NOTIFICATION_TIME_CHECK');
    }
    if (setNotification && !data.immediately && paymentYmdt > notificationYmdt) {
        utils_1.addErrorList(errorList, 'notificationRequestDate', 'ACCUMULATION_PAYMENT_REQUEST_ADD_NOTIFICATION_TIME_CHECK');
    }
    if (data.notificationChannels.length === 0 && setNotification) {
        utils_1.addErrorList(errorList, 'notificationChannels', 'ACCUMULATION_PAYMENT_REQUEST_NOTIFICATION_CHANNEL_EMPTY_ALERT');
    }
    if (setNotification && data.immediately && new Date().getTime() > notificationYmdt) {
        utils_1.addErrorList(errorList, 'notificationRequestDate', 'ACCUMULATION_PAYMENT_REQUEST_ADD_NOTIFICATION_TIME_USELESS_ALERT');
    }
    if (setNotification && !data.immediately && paymentYmdt > notificationYmdt) {
        utils_1.addErrorList(errorList, 'notificationRequestDate', 'ACCUMULATION_PAYMENT_REQUEST_ADD_NOTIFICATION_TIME_USELESS_ALERT');
    }
    return errorList;
}
exports.PostAccumulationsPaymentsRequestValidation = PostAccumulationsPaymentsRequestValidation;
// [Authority Group]
// [Board]
// [Post]
// [FAQ]
function getFaqsPublicFaqNoValidation(getFaqsPublicFaqNoRequest) {
    var errorList = [];
    var pathParams = getFaqsPublicFaqNoRequest.pathParams;
    if (!pathParams.faqNo) {
        utils_1.addErrorList(errorList, 'faqNo', 'GET_FAQ_PUBLIC_FAQNO_ERROR');
    }
    return errorList;
}
exports.getFaqsPublicFaqNoValidation = getFaqsPublicFaqNoValidation;
// [Inquiry]
// [Inquiry Answer Template]
// [Inquiry Type]
// [Internal Accumulation]
// [Internal Authority Group]
// [Internal]
// [Internal Mail Template]
// [Internal SMS Template]
// [Mail]
// [Mail Template]
// [Main]
// [Notice]
// [SMS]
// [SMS Template]
// [Terms]
// [TERMS]
